import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITipoTramite, TipoTramiteActividaDto, TipoTramiteDto, IGetHojaDeVidaJoinInfo } from '../../shared/interfaces/database/configuracion';


@Injectable({
  providedIn: 'root'
})
export class TipoTramiteService {
  private readonly baseUrl = `${environment.apiUrl}/api/tipo-tramite`;

  constructor(private readonly http: HttpClient) { }

  getTipoTramites(): Observable<ITipoTramite[]> {
    return this.http.get<ITipoTramite[]>(`${this.baseUrl}`);
  }

  getTipoTramite(id: number): Observable<ITipoTramite> {
    return this.http.get<ITipoTramite>(`${this.baseUrl}/${id}`);
  }

  getTipoTramitesSinDependencia(): Observable<ITipoTramite[]> {
    return this.http.get<ITipoTramite[]>(`${this.baseUrl}/sin-dependencia`);
  }

  createTipoTramite(request: TipoTramiteDto, firmaDeComprobante?: File): Observable<number> {
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    if (firmaDeComprobante) {
      formData.append('firmaDeComprobante', firmaDeComprobante);
    }
    return this.http.post<number>(`${this.baseUrl}`, formData);
  }

  updateTipoTramite(id:number, request: TipoTramiteDto, firmaDeComprobante?: File): Observable<string> {
    const formData = new FormData();
    if (firmaDeComprobante) {
      formData.append('firmaDeComprobante', firmaDeComprobante);
    }
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    return this.http.put(`${this.baseUrl}/${id}`, formData, { responseType: 'text' });
  }

  deleteTipoTramite(id: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }

  editarActividades(id: number, request: TipoTramiteActividaDto[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/editar-actividades/${id}`, request);
  }

  getHojaDeVidaJoinInfo(id: number): Observable<IGetHojaDeVidaJoinInfo> {
    return this.http.get<IGetHojaDeVidaJoinInfo>(`${this.baseUrl}/join-info/${id}`);
  }

  setProduccion(id: number, produccion: boolean): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/produccion/${id}`,{ produccion} );
  }
}
